import {type ValidationError} from "../../../infrastructure/types";

export const hasValidationMessage = (errors: ValidationError[]) =>
  errors?.filter(error => error)?.some(error => error?.message) ?? false;
